import { useEffect, useState } from "react";
import { useAuth } from "@/hooks/useAuth";
import { DEFAULT_HOME_PREF, type HomePref } from "@/domain/home_pref";
import { homePrefRepo } from "@/services/home_pref.repository";

/** 내 첫 화면 설정(users/{uid}/preferences/home). loaded 전에는 기본값(내 업무). */
export function useHomePref(): { pref: HomePref; loaded: boolean } {
  const { user } = useAuth();
  const uid = user?.uid ?? null;
  const [state, setState] = useState<{ uid: string | null; pref: HomePref } | null>(null);
  useEffect(() => homePrefRepo.watch(uid, (pref) => setState({ uid, pref })), [uid]);
  const cur = state && state.uid === uid ? state : null;
  return { pref: cur?.pref ?? DEFAULT_HOME_PREF, loaded: cur !== null };
}
